import { Construction, Truck, Building2, Shovel } from 'lucide-react';
import type { CategoryConfig } from '../types';

export const featuredCategories: CategoryConfig[] = [
  {
    title: "Professional Tool Hire",
    description: "Quality power tools and equipment for construction and renovation projects",
    icon: Construction,
    link: "/tool-hire/london"
  },
  {
    title: "Skip Hire Services",
    description: "Reliable waste management solutions for construction and clearance",
    icon: Truck,
    link: "/skip-hire/manchester"
  },
  {
    title: "Scaffold Tower Hire",
    description: "Safe and certified access equipment for working at height",
    icon: Building2,
    link: "/scaffold-tower-hire/birmingham"
  },
  {
    title: "Digger & Plant Hire",
    description: "Mini excavators and heavy machinery for groundwork projects",
    icon: Shovel,
    link: "/digger-hire/london"
  }
];